import React, {useState, useEffect, createContext, useContext} from "react";
import { OrgaAndRoles } from "../models/OrgaAndRoles";
import {StorageKey} from "../utils/storage/Keys";

function useSelectedOrganisation() {
  const [selectedOrganisation, setSelectedOrganisation] = useState<OrgaAndRoles | null>(null);

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(StorageKey.SELECTED_ORGANISATION);
    if (stored) {
      try {
        setSelectedOrganisation(JSON.parse(stored));
      } catch {
        // ignore parse errors
      }
    }
  }, []);

  const updateOrganisation = (org: OrgaAndRoles) => {
    setSelectedOrganisation(org);
    localStorage.setItem(StorageKey.SELECTED_ORGANISATION, JSON.stringify(org));
  };

  return { selectedOrganisation, setSelectedOrganisation: updateOrganisation };
}

export interface OrganisationContextValue {
  selectedOrganisation: OrgaAndRoles | null;
  setSelectedOrganisation: (org: OrgaAndRoles) => void;
}

const OrganisationContext = createContext<OrganisationContextValue | undefined>(undefined);

export const OrganisationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { selectedOrganisation, setSelectedOrganisation } = useSelectedOrganisation();
  return (
      <OrganisationContext.Provider value={{ selectedOrganisation, setSelectedOrganisation }}>
        {children}
      </OrganisationContext.Provider>
  );
};

export function useSelectedOrganisationContext() {
  const ctx = useContext(OrganisationContext);
  if (!ctx) throw new Error("useOrganisationContext must be used within OrganisationProvider");
  return ctx;
}
